import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmps-event-centre-card',
    template: ` <ng-content select="cmps-event-centre-card-stripe"></ng-content>
        <ng-content select="cmps-event-centre-card-name"></ng-content>
        <ng-content select="cmps-event-centre-card-message"></ng-content>`,
    host: {
        class: 'cmps-event-centre-card',
        '[class.cmps-event-centre-card--expanded]': 'expanded',
    },
})
export class CardComponent {
    @Input() expanded: boolean;
}
